import { createSelector } from 'reselect';
import _ from 'lodash';

import featureFlags from '../../util/featureFlags';
import * as projectSelector from './cardProjectSelector';

export const getSubtotal = state => state.cards.customization.review.total.all;
export const getPendingChanges = state => state.cards.customization.hasPendingChanges;

// formHistory selectors
export const getFormHistory = state => state.cards.formHistory;

// customizationBar selectors
export const getCustomizationErrorsByElementUUID = state => state.cards.cardCustomizationBar.errorsByElementUUID;

export const getCustomizationHasErrors = createSelector(
  getCustomizationErrorsByElementUUID,
  (errorsByElementUUID) => {
    if (errorsByElementUUID && errorsByElementUUID.length > 0) {
      return true;
    }
    return false;
  }
);

// recipients selectors
const getGuestGroups = state => state.guestList.guests.byId;
export const getSelectedGuestIds = state => state.cards.recipients.selectedGuestIds;
export const getFontSizeOverrides = state => state.cards.recipients.fontSizeOverrides;
export const getIsFirstFontResizeComplete = state => featureFlags.get('invitesGuestFontOverrides') ? state.cards.recipients.isFirstFontResizeComplete : true;
export const getInvitedGuestsCount = state => state.guestList.guests.orderedIds.length || 0;

export const getGuestGroupsMissingEmailIds = createSelector(
  getGuestGroups,
  getSelectedGuestIds,
  (guestGroups, selectedGuestIds) => _.filter(
    selectedGuestIds,
    id => guestGroups[id] && (guestGroups[id].email_address === null || guestGroups[id].email_address === '')
  )
);

export const getIsGuestListMissingEmail = createSelector(
  getGuestGroupsMissingEmailIds,
  (missingEmailIds) => missingEmailIds.length > 0
);

export const getCurrentStepByPathName = () => {
  if (window) return window.location.pathname.split('/').pop();
  return null;
};

export const getCustomizationUUIDByType = createSelector(
  projectSelector.getCustomizationTypeUUIDs,
  projectSelector.getProjectType,
  (customizationTypeToUUID, cardType) => customizationTypeToUUID[cardType]
);

export const getPageNumberByStep = createSelector(
  projectSelector.getSteps,
  getCurrentStepByPathName,
  (steps, currentStep) => {
    // temp workaround while digital animation pages use customization code
    if (
      currentStep === 'digitalOrder/:projectUUID'
      || currentStep === 'digitalPreview/:projectUUID'
      || currentStep === ':uuid'
    ) return 0;
    return steps[currentStep].pageNumber;
  }
);

export const getPage = createSelector(
  projectSelector.getCustomizations,
  getCustomizationUUIDByType,
  projectSelector.getPageEntities,
  getPageNumberByStep,
  (customizations, customizationUUID, pageEntities, pageNumber) => {
    const customization = customizations[customizationUUID];
    const pages = customization.pages.map(pageUUID => pageEntities[pageUUID]);
    const page = _.find(pages, { page_number: pageNumber + 1 });
    return page;
  }
);

export const getElementUUIDs = createSelector(
  getPage,
  page => page.elements
);



// WEBPACK FOOTER //
// ./src/cards/selectors/Customization.js